export default __webpack_public_path__ + "static/media/ic-file.ccdd6d83.svg";